module.exports = __webpack_public_path__ + "img/fjPick.3ea12888.png";